module.exports = __webpack_public_path__ + "img/credit_carburant_dark_mode.def2af5c.svg";